import React from 'react';
import {
  TextInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';


export const subMerchantFilters = [
  <TextInput source="name" alwaysOn={true} />,
  <ReferenceInput source='submerchantID' reference='SubMerchant' alwaysOn={true}>
    <AutocompleteInput
      optionText='name'
      label="SubMerchant"
      sx={{ width: '220px' }}
    />
  </ReferenceInput>
];
